// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// BROWSER MATCH REPLACE CONDITIONS SCHEMA
/////////////////////////////////////////

export const BrowserMatchReplaceConditionsSchema = z.object({
  urlPattern: z.string().nullable(),
  methods: z.string().array(),
  statusCodes: z.number().int().array(),
  contentTypes: z.string().array(),
})

export type BrowserMatchReplaceConditions = z.infer<typeof BrowserMatchReplaceConditionsSchema>

export default BrowserMatchReplaceConditionsSchema;
